import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export const ms = (s) => new Date(s).getTime();
export const fmtClock = (sec) => `${Math.floor(sec / 60)}:${String(Math.max(0, sec % 60)).padStart(2, "0")}`;

export function phaseOf(ev, t) {
  if (!ev) return null;
  if (t < ms(ev.start_at)) return "countdown";
  if (t < ms(ev.end_at)) return "raining";
  return "done";
}

export function useGoldRain(userId) {
  const [ev, setEv] = useState(null);
  const [offset, setOffset] = useState(0);
  const load = useCallback(() => api.get("/goldrain/current").then(({ data }) => {
    if (data) setOffset(ms(data.server_now) - Date.now());
    setEv((prev) => (data && prev && prev.id === data.id ? { ...data, my_coins: Math.max(data.my_coins || 0, prev.my_coins || 0) } : data || null));
  }).catch(() => {}), []);
  useEffect(() => {
    if (!userId) return;
    load();
    const iv = setInterval(load, 15000);
    const onVis = () => document.visibilityState === "visible" && load();
    const onMsg = (e) => e.data?.type === "goldrain" && load();
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("goldrain-changed", load);
    navigator.serviceWorker?.addEventListener("message", onMsg);
    return () => { clearInterval(iv); document.removeEventListener("visibilitychange", onVis); window.removeEventListener("goldrain-changed", load); navigator.serviceWorker?.removeEventListener("message", onMsg); };
  }, [userId, load]);
  return { ev, setEv, offset, reload: load };
}

export function useClock(offset, every, active) {
  const [t, setT] = useState(() => Date.now() + offset);
  useEffect(() => {
    setT(Date.now() + offset);
    if (!active) return;
    const iv = setInterval(() => setT(Date.now() + offset), every);
    return () => clearInterval(iv);
  }, [offset, every, active]);
  return t;
}
